import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import axios from "axios";
import VueRouter from "vue-router";
import Routes from "./routes";
import VueAxios from "vue-axios";

import "./plugins";
import Bootstrap from "bootstrap-vue";
import "vue-awesome/icons/arrow-left";
import "vue-awesome/icons/user-circle";
import "vue-awesome/icons/brands/facebook-f";
import "vue-awesome/icons/check-circle";
import "vue-awesome/icons/plus-circle";
import "vue-awesome/icons/exclamation-circle";
import "vue-awesome/icons/chevron-left";
import unleshConfig from "./unleash";
import Analytics from "./plugins/analytics";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "./assets/scss/auth.scss";
import VueCountryCode from "vue-country-code";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import GlobalMixin from './components/mixins/Global';
import Icon from "vue-awesome/components/Icon";

Icon.register({
  back: {
    width: 1024,
    height: 1024,
    raw: '<path d="M854.699 470.699v83.968h-520.192l238.592 239.616-60.416 60.416-342.016-342.016 342.016-342.016 60.416 60.416-238.592 239.616z"></path>',
  },
});

Vue.component("v-icon", Icon);

Vue.use(VueCountryCode);

Vue.use(VueAxios, axios);
Vue.use(VueRouter);
Vue.use(Bootstrap);

Vue.config.productionTip = false;
Vue.mixin(unleshConfig);
Vue.mixin (GlobalMixin);

Vue.use(VueToast);

const router = new VueRouter({
  mode: "history",
  routes: Routes,
  base: "/",
  duplicateNavigationPolicy: "ignore",
});
Vue.use(Analytics, router);

Sentry.init({
  Vue,
  dsn: window.env.SENTRY_URL,
  release: "latest",
  environment: window.env.SENTRY_ENV,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [/\.livspace\.com$/],
    }),
  ],
  tracesSampleRate: 1.0,
});

new Vue({
  render: (h) => h(App),
  router: router,
  store,
}).$mount("#app");
